import { render } from "./roomItemList.vue?vue&type=template&id=0c71a3e4&scoped=true"
import script from "./roomItemList.vue?vue&type=script&lang=js"
export * from "./roomItemList.vue?vue&type=script&lang=js"

import "./roomItemList.vue?vue&type=style&index=0&id=0c71a3e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c71a3e4"]])

export default __exports__